class ResearchOutputSearchFieldState {
  constructor(researchOutputSearchFieldState = {}) {
    this.status = !!researchOutputSearchFieldState.status;
    this.category = !!researchOutputSearchFieldState.category;
  }
}

export default ResearchOutputSearchFieldState;
